// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SwapVert: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 38" enableBackground="new 0 0 30 38" xmlSpace="preserve">
<g>
	<polygon points="23.33,29.44 23.33,14.83 19.17,14.83 19.17,29.44 12.92,29.44 21.25,37.75 29.58,29.44 	"/>
	<polygon points="8.75,0.25 0.42,8.56 6.67,8.56 6.67,23.17 10.83,23.17 10.83,8.56 17.08,8.56 	"/>
</g>
</svg>;
};

export default React.memo(SwapVert);
